import api from '../../utils/api';

// Interface for the comprehensive dashboard response
export interface SalesExecutiveDashboardData {
  vendorsOnboardedThisMonth: number;
  pendingVerifications: number;
  averageOnboardingTime: string;
  totalVendorsAdded: number;
  vendorWiseCounts: {
    [key: string]: number;
  };
  vendorStatusDistribution: {
    approved: number;
    pending: number;
    rejected: number;
  };
  monthlyOnboardingTrend: Array<{
    month: string;
    count: number;
  }>;
  vendorCategoryDistribution: Array<{
    label: string;
    value: number;
  }>;
}

// Fetch comprehensive dashboard data for a specific sales executive
export const fetchSalesExecutiveDashboardData = async (salesExecutiveId: string): Promise<SalesExecutiveDashboardData> => {
  try {
    const response = await api.get(`/master-admin/sales-executive/dashboard-stats/${salesExecutiveId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching sales executive dashboard data:', error);
    throw error;
  }
}; 